import { dsl } from '@wix/yoshi-serverless/wrap';

export const query = dsl({
          functionName: 'query',
          fileName: 'api/events/events.api',
        });

export const getConnectedEvents = dsl({
          functionName: 'getConnectedEvents',
          fileName: 'api/events/events.api',
        });

export const create = dsl({
          functionName: 'create',
          fileName: 'api/events/events.api',
        });

export const remove = dsl({
          functionName: 'remove',
          fileName: 'api/events/events.api',
        });

export const update = dsl({
          functionName: 'update',
          fileName: 'api/events/events.api',
        });